import { ModalComponent } from './../modal/modal.component';
import { ModalService } from './../../services/modal/modal.service';
import { Component, OnInit, Input } from '@angular/core';
import { ScreenUtils } from '../../utils/screen.utils';
import {AbTestService} from '../../services/abTest.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ds-transfer-marquee',
  templateUrl: './transfer-marquee.component.html',
  styleUrls: ['./transfer-marquee.component.scss']
})
export class TransferMarqueeComponent extends ModalComponent implements OnInit {

  @Input() tags: string[];
  @Input() freeWifi: boolean;
  @Input() familiesRecommended: boolean;
  @Input() direct: boolean;
  @Input() meetAndGreet: boolean;
  @Input() hovered;
  sliderItems: MarqueeItem[] = [];
  MAX_SLIDER_ITEMS = 4;
  isMobile: boolean;
  isDesktop: boolean;
  marqueeModalTitle: string;
  marqueeModalDescription: string;

  constructor(
      protected modalService: ModalService,
      private readonly abTestService: AbTestService,
      private readonly translate: TranslateService
  ) {
    super(modalService);
  }

  ngOnInit() {
    this.setSliderItems();
    this.isMobile = ScreenUtils.isMobile();
    this.isDesktop = ScreenUtils.isDesktop();
    if (this.isMobile && this.hasFreeCancellation()) {
        this.setModalTitleAndDescription();
    }
  }

  public setSliderItems() {
    if (this.hasMintur()) {
      this.sliderItems.push({
        text: 'transfer-marquee.mintur',
        freeCancellation: false, mintur: true,
        mostPurchased: false, freeWifi: false, familiesRecommended: false, direct: false
      });
    }
    if (this.hasFreeCancellation()) {
      this.sliderItems.push({
        text: 'transfer-marquee.freeCancellation',
        freeCancellation: true, mintur: false,
        mostPurchased: false, freeWifi: false, familiesRecommended: false, direct: false
      });
    }
    if (this.hasMostPurchased() && this.isMostPurchasedAbTestEnabled()) {
      this.sliderItems.push({
        text: 'transfer-marquee.mostPurchased',
        freeCancellation: false, mintur: false,
        mostPurchased: true, freeWifi: false, familiesRecommended: false, direct: false
      });
    }
    if (this.freeWifi) {
      this.sliderItems.push({
        text: 'transfer-marquee.freeWifi',
        freeCancellation: false, mintur: false,
        mostPurchased: false, freeWifi: true, familiesRecommended: false, direct: false
      });
    }
    if (this.familiesRecommended) {
      this.sliderItems.push({
        text: 'transfer-marquee.familiesRecommended',
        freeCancellation: false, mintur: false,
        mostPurchased: false, freeWifi: false, familiesRecommended: true, direct: false
      });
    }
    if (this.meetAndGreet) {
      this.sliderItems.push({
        text: 'transfer-marquee.meetgreet',
        freeCancellation: false, mintur: false,
        mostPurchased: false, freeWifi: false, familiesRecommended: false, direct: false
      });
    }
    if (this.sliderItems.length < this.MAX_SLIDER_ITEMS && this.direct) {
      this.sliderItems.push({
        text: 'transfer-marquee.direct',
        freeCancellation: false, mintur: false,
        mostPurchased: false, freeWifi: false, familiesRecommended: false, direct: true
      });
    }
  }

  private hasFreeCancellation(): boolean  {
    return this.tags !== null && this.tags.includes('flexible_cancellation_policy');
  }

  private hasMintur(): boolean  {
    return this.tags !== null && this.tags.includes('mintur');
  }

  private hasMostPurchased(): boolean {
    return this.tags !== null && this.tags.includes('most_purchased');
  }

  private isMostPurchasedAbTestEnabled(): boolean {
      return this.abTestService.isTestBranch('S-TRANSFERS-BEST-SELLER');
  }

  public isDefaultDriver(item: MarqueeItem): boolean {
    return !item.freeCancellation && !item.mintur && !item.mostPurchased && !item.freeWifi && !item.familiesRecommended && !item.direct;
  }


  public setModalTitleAndDescription(): void {
     this.marqueeModalTitle = this.translate.instant('transfer-marquee.freeCancellation.tooltip.title');
     this.marqueeModalDescription = this.translate.instant('transfer-marquee.freeCancellation.tooltip.description');
  }
}

export interface MarqueeItem {
  text: string;
  freeCancellation: boolean;
  mintur: boolean;
  mostPurchased: boolean;
  freeWifi: boolean;
  familiesRecommended: boolean;
  direct: boolean;
}
